<template>
    <ds-modal
        data-qa="unlayer-email-builder-ftu-modal"
        show-close
        :title="$options.MESSAGE_CONSTANTS.UNLAYER_EMAIL_BUILDER_FTU_MODAL.TITLE"
        :is-open="isOpen"
        @close="$emit('close')"
    >
        <div class="modal-content">
            <img src="/resources/broadcast/images/broadcasts-new-look.svg" />

            <h3>
                {{ $options.MESSAGE_CONSTANTS.UNLAYER_EMAIL_BUILDER_FTU_MODAL.HEADING }}
            </h3>

            <p>
                {{ $options.MESSAGE_CONSTANTS.UNLAYER_EMAIL_BUILDER_FTU_MODAL.DESCRIPTION }}
            </p>

            <div class="actions">
                <ds-filled-button trailing-icon="arrow-long-right" data-qa="unlayer-email-builder-ftu-modal-get-started-button" @click="$emit('close')">
                    {{ $options.MESSAGE_CONSTANTS.UNLAYER_EMAIL_BUILDER_FTU_MODAL.GET_STARTED }}
                </ds-filled-button>

                <ds-text-button
                    as="a"
                    href="https://help.infusionsoft.com/help/send-a-broadcast-with-the-new-email-builder"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {{ $options.MESSAGE_CONSTANTS.UNLAYER_EMAIL_BUILDER_FTU_MODAL.LEARN_MORE }}
                </ds-text-button>
            </div>
        </div>
    </ds-modal>
</template>

<script>
import { MESSAGE_CONSTANTS } from '@/components/broadcast/constants/emailBroadcast.constants.js';

export default {
    MESSAGE_CONSTANTS,

    props: {
        isOpen: Boolean,
    },
};
</script>

<style lang="scss" scoped>
.modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

img {
    max-width: px-to-rem(500);
}

h3 {
    margin-bottom: $spacing-200;
    font-weight: $font-weight-bold;
}

p {
    font-size: $font-size-md;
    line-height: $line-height-lg;
}

.actions {
    margin-top: $spacing-100;
    display: flex;
    gap: $spacing-100
}
</style>
